import React from "react";
import { menuData } from "../utils";

const NavigationDots = ({ active }) => {
  return (
    <div className="mainpage__navigation navigation-dots">
      {menuData.map((item, idx) => (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a
          key={item + idx}
          href={`#${item}`}
          className="navigation-dots__dot"
          style={active === item ? { backgroundColor: "#313BAC" } : {}}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
